/**
 * Simple tell whether agent seems to be mobile
 * @returns {boolean}
 */
export function isMobile() {
    return window.navigator.userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i) !== null;
}
/**
 * Modifies body theme from dark to light or the other way around
 * @param {string} theme
 */
export function toggleBodyTheme(theme) {
    var otherTheme = theme;
    if (theme.includes('dark')) {
        otherTheme = otherTheme.replace('dark', 'light');
    }
    else {
        otherTheme = otherTheme.replace('light', 'dark');
    }
    document.body.classList.remove(otherTheme);
    document.body.classList.add(theme);
}
//# sourceMappingURL=browser.js.map